import React, { useState } from 'react'
import { 
    Accordion, 
    AccordionDetails, 
    AccordionSummary, 
    Alert, 
    Box, 
    Button, 
    IconButton, 
    Snackbar, 
    Stack, 
    Tooltip, 
    Typography 
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListaDiagramas from './ListaDiagramas';
import { arrayRemove, collection, deleteDoc, doc, getDocs, updateDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/firebase';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import ModalSistema from './Alertas/ModalSistema';
import CircleIcon from '@mui/icons-material/Circle';
import ModalAgregarDiagrama from './Alertas/ModalAgregarDiagrama';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const ListaColecciones = (props) => {

    const {colecciones, diagramas, obtenerColecciones, actualizarDiagramas, nombreColeccion, colorColeccion} = props;

    const [expanded, setExpanded] = useState(false);
    const [diagramasActuales, setDiagramasActuales] = useState([])
    
    const user = auth.currentUser;
    const navigate = useNavigate();
    const [nodosDiagrama, setNodosDiagrama] = useState([]);
    const [lineasDiagrama, setLineasDiagrama] = useState([]);
    
    const [abrirModal, setAbrirModal] = useState(false);
    const handleClose = () => setAbrirModal(false);
    
    // Modal para eliminar una colección
    const [abrirModalEliminar, setAbrirModalEliminar] = useState(false);
    const handleCloseEliminar = () => setAbrirModalEliminar(false);
    const [coleccionEliminar, setColeccionEliminar] = useState('');
    
    // Modal para agregar mas diagramas
    // dentro de una colección creada
    const [abrirModalAgregar, setAbrirModalAgregar] = useState(false);
    const handleCloseAgregar = () => setAbrirModalAgregar(false);
    const [arrayDiagramas, setArrayDiagramas] = useState([]);
    const [coleccionActual, setColeccionActual] = useState(null);

    //Hooks para quitar diagrama de coleccion
    const [idColeccion, setIdColeccion] = useState('');
    const [idDiagrama, setidDiagrama] = useState('')
    const [arregloDiagramas, setArregloDiagramas] = useState([]);

    //Para abrir el snackbar
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(true);
        setTimeout(() => {
            setOpen(false);
        }, 3000);
    };


    const obtenerDiagramas = async() =>{
        try {

        const querySnapshot = await getDocs(collection(db, user.uid));
        const arrayData = querySnapshot.docs.map( doc => 
            (
            {idDocumento: doc.id, ...doc.data()}
            ))      
        setDiagramasActuales(arrayData);
        
        } catch (error) {
        
        }
    }
    

    useEffect(() => {
        obtenerDiagramas();
    }, [])

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const guardarInfo = (coleccion) =>{
        /* console.log(coleccion) */
    }

    const editarDiagrama = (id) =>{
        let titulo = '';
        let fecha = '';

        diagramas.forEach((diagrama)=>{
            if(diagrama.idDocumento === id){

                diagrama.nodos.forEach((node)=>{
                let newNode = JSON.parse(node);
                /* console.log(newNode); */
                nodosDiagrama.push(newNode)
                })

                diagrama.lineas.forEach((line)=>{
                let newLine = JSON.parse(line);
                /* console.log(newLine) */
                lineasDiagrama.push(newLine);
                })

                titulo = diagrama.titulo;
                fecha = diagrama.fecha;
            }
        })

        navigate('/lienzo', 
        {state:
            {
            idDocumento:id, 
            titulo: titulo,
            fecha: fecha,
            nodosDiagrama: nodosDiagrama, 
            lineasDiagrama: lineasDiagrama,
            }
        })
    }
    
    const handleDelete = async() =>{
        /* console.log('Quitar diagrama '+idDiagrama+' de la coleccion '+idColeccion)
        console.log(arregloDiagramas); */
        let diagramasAux = [];

        arregloDiagramas.forEach((diagrama)=>{
            if(diagrama.idDocumento !== idDiagrama){
                diagramasAux.push(diagrama)
            }
        })
        
        await updateDoc(doc(db, 'colecciones', idColeccion),{
            diagramas: diagramasAux
        })

        let nombre = '';
        colecciones.forEach((cole)=>{
            if(cole.id === idColeccion){
                nombre = cole.nombre;
            }
        })

        updateDoc(doc(db, user.uid, idDiagrama),{
            coleccion: arrayRemove(nombre)
        })

        

        setidDiagrama('');
        setIdColeccion('');
        setArregloDiagramas([]);
        obtenerColecciones();
        setAbrirModal(false);
        handleClick();
    }

    //En realidad solo lo quitamos de la coleccion
    const eliminarDiagrama = (idDocumento, coleccionActual, diagramas) =>{
        setidDiagrama(idDocumento);
        setIdColeccion(coleccionActual);
        setArregloDiagramas(diagramas);
        setAbrirModal(true);
    }

    const modalAgregar = (coleccion) =>{
        setColeccionActual(coleccion);
        setAbrirModalAgregar(true);
    }

    const eliminarColeccion = async() =>{

        obtenerColecciones();
        obtenerDiagramas();

        let nombreCole = '';

        colecciones.forEach((cole)=>{
            if(cole.id === coleccionEliminar.id){
                nombreCole = cole.nombre;
            }
        })

        diagramasActuales.forEach((diagram)=>{
            if(diagram.coleccion.includes(nombreCole)){
                updateDoc(doc(db, user.uid, diagram.idDocumento),{
                    coleccion: arrayRemove(nombreCole)
                })
            }
        })

                
        await deleteDoc(doc(db, 'colecciones', coleccionEliminar.id));
        obtenerColecciones();
        setAbrirModalEliminar(false);
        
    }


    const handleButtonDelete = (coleccion) =>{
        setColeccionEliminar(coleccion);
        setAbrirModalEliminar(true);
    }

    return (
        <>
            {
                colecciones.map((coleccion, i) => (
                    <div key={i}>
                        <Accordion expanded={expanded === i} onChange={handleChange(i)}>
                            
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                {/* <Button sx={{ width: '30%', flexShrink: 0 }}> */}
                                    <Typography 
                                        sx={{ width: '33%', flexShrink: 0, fontWeight: 'bold'}}
                                        variant='h5'
                                    >
                                        {coleccion.nombre}
                                    </Typography>
                                {/* </Button> */}

                                <Typography sx={{ color: 'text.secondary', width: '80%' }}>
                                    {coleccion.id}
                                </Typography>

                                <Tooltip title='Agregar elemento'>
                                    <IconButton
                                        color='primary'
                                        size='medium'
                                        variant='outlined'
                                        onClick={()=>{modalAgregar(coleccion)}}
                                        >
                                        <AddCircleOutlineIcon fontSize='medium'/>
                                    </IconButton>
                                </Tooltip>
                                
                                <Tooltip title='Eliminar colección'>
                                    <IconButton
                                        onClick={()=>{handleButtonDelete(coleccion)}}
                                        color='error'
                                        size='small'
                                        variant='outlined'
                                        >
                                        <DeleteForeverIcon fontSize='medium'/>
                                    </IconButton>
                                </Tooltip>


                                <Tooltip title='Color de colección'>
                                    <IconButton sx={{ color: coleccion.color }} align="right">
                                        <CircleIcon
                                            size='large'
                                        />
                                    </IconButton>
                                </Tooltip>
                            </AccordionSummary>

                            <AccordionDetails>
                                <ListaDiagramas
                                    diagramas={coleccion.diagramas}
                                    editarDiagrama={editarDiagrama}
                                    eliminarDiagrama={eliminarDiagrama}
                                    idColeccion={coleccion.id}
                                    nombreColeccion={nombreColeccion}
                                    subcol = {true}
                                />
                            </AccordionDetails>
                            <AccordionDetails>
                                <Box textAlign='center'>
                                    <Tooltip title='Nuevo diagrama' >
                                        <Button
                                            color='primary'
                                            size='medium'
                                            variant='outlined'
                                            endIcon={
                                                <AddCircleOutlineIcon
                                                    fontSize='large'
                                                    />
                                            }
                                            onClick={()=>{navigate('/lienzo')}} 
                                            >
                                            NUEVO
                                        </Button>
                                    </Tooltip>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                        {abrirModalEliminar && (
                            <ModalSistema
                                abrirModal={abrirModalEliminar}
                                handleClose={handleCloseEliminar}
                                funcion={eliminarColeccion}
                                titulo={'Eliminar colección'}
                                mensaje={'¿Desea eliminar la colección de forma permanente?'}
                            />
                        )}

                        {abrirModal && (
                            <ModalSistema
                                abrirModal={abrirModal}
                                handleClose={handleClose}
                                funcion={handleDelete}
                                titulo={'Quitar diagrama'}
                                mensaje={'¿Desea quitar el diagrama de la colección?'}
                            />
                        )}
                        {abrirModalAgregar && (
                            <ModalAgregarDiagrama
                                abrirModalAgregar={abrirModalAgregar}
                                handleCloseAgregar={handleCloseAgregar}
                                coleccion={coleccionActual}
                                diagramas={diagramasActuales}
                                obtenerColecciones={obtenerColecciones}
                                nombreColeccion={nombreColeccion}
                                obtenerDiagramas={obtenerDiagramas}
                            />
                        )}
                        <Stack spacing={2} sx={{ width: '100%' }}>
                            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
                                <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                                    Completado!
                                </Alert>
                            </Snackbar>
                        </Stack>
                    </div>
                ))
            }
        </>
    )
}

export default ListaColecciones